import { createCRUD } from '@/api/axios';

export default {
  ...createCRUD('tags'),
};
